import { apiGet } from '@/store/actions'

const fetchSkills = async (context: any) => {
  const { data } = await apiGet(context, 'skills')
  return data
}

const getSkillInfo = async (context: any, skillId: number) => {
  const { data } = await apiGet(context, `skills/${skillId}`)
  return data
}

export default {
  fetchSkills,
  getSkillInfo
}
